import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Danhmucxedienexcel from "components/Xuatexcel/Danhmuc/Danhmucxedienexcel.js";
import Box from "@mui/material/Box";
import Config from "conFig.js";
import dayjs from "dayjs";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const xdcolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "stt",
    headerName: "STT",
    width: 70,
    headerAlign: "center",
  },
  {
    field: "tendonvi",
    headerName: "Tên đơn vị",
    width: 350,
    headerAlign: "center",
  },
  {
    field: "bienkiemsoat",
    headerName: "Biển kiểm soát",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "tuyenhoatdong",
    headerName: "Tuyến hoạt động",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "coquankiemdinh",
    headerName: "Cơ quan kiểm định",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "thoihankiemdinhcuoi",
    headerName: "Thời hạn kiểm định",
    width: 180,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
];

export default function Danhmucxedien() {
  const [pageSize, setPageSize] = React.useState(50);
  const [xedien, setXedien] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Danhmucxedienexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const getdanhmuc = () => {
    var url = Config.backend + "/api/Donvi/getxedien?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXedien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getdanhmuc();
  }, []);

  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button color="primary" variant="contained" style={{ height: 27 }}>
          Thêm mới
        </Button>
        <Button
          variant="contained"
          style={{
            marginLeft: 10,
            color: "#fff",
            backgroundColor: "#BB2124",
            height: 27,
          }}
        >
          Xóa
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={xedien}
            columns={xdcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
